export default "__VITE_ASSET__tIpopjvO__"